/**
 * External dependencies
 */
import { css } from '@emotion/native';

export default css;
